export default __webpack_public_path__ + "static/media/pexels-pavel-danilyuk-8381268.da74b707.mp4";